//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { calVariables, request, whereGql } from '@/graphql/util';
import dayjs from 'dayjs';
// import { Diff2HtmlUI } from 'diff2html/lib/ui/js/diff2html-ui-slim.js';
// import 'diff2html/bundles/css/diff2html.min.css';
// import { createTwoFilesPatch } from 'diff';
import MyDiff2Html from '@/components/diff2Html';
export default {
  components: {
    MyDiff2Html,
  },
  data() {
    return {
      // 表单
      searchForm: {
        key: '',
        desc: '',
        modules: '',
        type: '',
        oprator_name: '',
        create_time: '',
        page: 1,
        size: 10,
      },
      // 表格
      loading: false,
      list: [{ status: 'Active' }],
      // 选项数据
      object: {},
      total: 0,
      detail: {},
      userList: [],
      timeout: null,
      // Diff 弹窗相关
      diffDialogVisible: false,
      currentDiffData: null,
      diffType: 'side-by-side',
      // 数组数据差异弹窗相关
      arrayDiffDialogVisible: false,
      currentArrayDiffData: null,
      arrayDiffType: 'side-by-side',
    };
  },
  computed: {
    typeOptions() {
      if (!this.object.fields) {
        return [];
      }
      const { options } = this.object.fields.find((item) => {
        return item.name === 'type';
      }).select_one_option;
      return options;
    },
    typeValue() {
      const obj = {};
      this.typeOptions.forEach((item) => {
        obj[item.value] = item;
      });
      return obj;
    },
    modulesOptions() {
      if (!this.object.fields) {
        return [];
      }
      const { options } = this.object.fields.find((item) => {
        return item.name === 'modules';
      }).select_one_option;
      return options;
    },
    modulesValue() {
      const obj = {};
      this.modulesOptions.forEach((item) => {
        obj[item.value] = item;
      });
      return obj;
    },
  },
  created() {
    this.getList();
    this.getObject();
  },
  methods: {
    searchList() {
      this.searchForm.page = 0;
      this.getList();
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.searchList();
    },
    async getList() {
      this.loading = true;
      const getRecordingGql = `query{$tableName (_limit:$limit,_offset:$offset,$filter,_order_by: {create_time: _desc, id:_desc}) {_aggregate{_count}_all}} `;
      try {
        let filterArr = [];
        const { size, page } = this.searchForm;
        if (this.searchForm.key) {
          filterArr = [
            {
              whereGqlType: 'eq',
              key: `${this.searchForm.key}`,
            },
          ];
        }
        if (this.searchForm.desc) {
          filterArr = [
            {
              whereGqlType: 'like',
              desc: `%${this.searchForm.desc}%`,
            },
          ];
        }
        if (this.searchForm.type) {
          filterArr.push({
            whereGqlType: 'like',
            type: `%${this.searchForm.type}%`,
          });
        }
        if (this.searchForm.modules) {
          filterArr.push({
            whereGqlType: 'like',
            modules: `%${this.searchForm.modules}%`,
          });
        }
        if (this.searchForm.oprator_name) {
          filterArr.push({
            whereGqlType: 'like',
            oprator_name: `%${this.searchForm.oprator_name}%`,
          });
        }
        if (this.searchForm.create_time) {
          const startDate = new Date(this.searchForm.create_time[0]);
          const endDate = new Date(this.searchForm.create_time[1]);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          filterArr.push(
            {
              whereGqlType: 'min',
              create_time: Math.floor(startDate.getTime() / 1000),
            },
            {
              whereGqlType: 'max',
              create_time: Math.floor(endDate.getTime() / 1000),
            },
          );
        }
        const data = {
          limit: size,
          offset: size * (page - 1),
          tableName: 'conf_audit_log',
          filter: whereGql(filterArr),
        };
        const result = await request(
          '/api/access/pb/cmd/DataAdminServer/MetadataOtherInfo/QueryWithCheck',
          {
            query: calVariables(getRecordingGql, data),
          },
        );
        this.list = result.conf_audit_log._data;
        this.total = result.conf_audit_log._aggregate.count;
        this.loading = false;
      } catch (err) {
        console.log('getList err:', err);
        this.list = [];
        this.total = 0;
        this.loading = false;
      }
    },
    async getObject() {
      try {
        const { list } = await this.$request({
          url: '/api/access/pb/cmd/DataServer/MetadataService/GetObjectsByNames',
          data: {
            objects: ['conf_audit_log'],
          },
        });
        this.object = list[0];
      } catch (err) {
        console.log(err);
      }
    },

    // 分页器
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.searchForm.page = 1;
      this.getList();
    },
    // 时间格式化
    formatDate(val) {
      if (!val) return '-';
      return dayjs(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    // 筛选
    filterModules(value, row) {
      return row.modules === value;
    },
    filterType(value, row) {
      return row.type === value;
    },
    getTypeValue(list, val) {
      list = Object.values(list);
      return list.find(({ value }) => value === val)?.label || val;
    },
    getModulesValue(list, val) {
      list = Object.values(list);
      return list.find(({ value }) => value === val)?.label || val;
    },
    getValue(val) {
      if (val === null) {
        return '';
      }
      switch (typeof val) {
        case 'string':
          return `${val}`;
        case 'boolean':
          return val ? 'true' : 'false';
        case 'number':
          return `${val}`;
        case 'undefined':
          return '';
        default:
          return JSON.stringify(val);
      }
    },
    querySearchAsync(queryString, cb) {
      const url = '/api/access/pb/cmd/AuthAdminServer/AuthAdminUser/GetUserList';
      const data = {
        keyword: queryString,
        page: 1,
        type: 1,
        page_size: 10,
      };
      this.$request({ url, data }).then((data) => {
        this.userList = data.data.map((i) => {
          return {
            label: i.account,
            value: i.name,
          };
        });
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const results = this.userList;
        cb(results);
      }, 3000 * Math.random());
    },

    // Diff 相关方法
    handleDiff(diffData) {
      this.currentDiffData = diffData;
      this.diffDialogVisible = true;
    },

    handleArrayDiff(diffData) {
      let diffDataArr = [];
      try{
        if(typeof diffData === 'string') {
          diffDataArr = JSON.parse(diffData) || diffData;
          if(Array.isArray(diffDataArr)) {
            diffDataArr = diffDataArr.map((item, index) => ({
              ...item,
              fileName: item.path
                ? Array.isArray(item.path)
                  ? item.path.join('/')
                  : item.path
                : `变更项${index + 1}`,
            }));
          }
        }
      }catch(e) {}
      this.currentArrayDiffData = diffDataArr;
      this.arrayDiffDialogVisible = true;
    },
  },
};
